import { TransactionType } from '@superbet-group/web.types';

export enum TransactionMethod {
    PaySafe = 'paysafe',
    SafeCharge = 'safecharge',
    Bank = 'bank',
    Agency = 'agency',
    Monri = 'monri',
    PaymentIQ = 'paymentiq',
    Transaks = 'transaks',
    Paybrokers = 'paybrokers',
    Okto = 'okto',
}

export enum TransactionChannel {
    Desktop = 'desktop',
    Mobile = 'mobile',
}

export type SeonSession = string;

export type SeonConfig = {
    dnsResolverDomain: string;
};

export interface Transaction {
    method: TransactionMethod;
    type: TransactionType;
    transactionData?: Record<string, unknown>;
}

export interface Deposit {
    method: TransactionMethod;
    transactionData?: Record<string, unknown>;
}

export interface Withdrawal {
    method: TransactionMethod;
    transactionData?: Record<string, unknown>;
}

export interface SessionStorageService {
    clear(): void;
    exists(): boolean;
    get(): SeonSession;
    getId(): string;
    set(session: SeonSession): void;
    setId(sessionId: string): void;
}

export interface SeonService {
    getSession(config: SeonConfig): Promise<SeonSession>;
}
